import React from 'react';

const SkillItem = ({title, height, type}) => (
	<div className={["single-skill", type].join(' ')}>
		<div className="after-li">
			<div className="singel-hr">
				<div className="singel-hr-inner" data-height={height}>
					<div className="skill-visiable">
						<span className="skill-title">{title}</span>
						<div className="hr-wrap">
							<div className="hrc"/>
						</div>
					</div>
				</div>
				<span className="skill-count">{height}</span>
			</div>
		</div>
	</div>
);

export default SkillItem;



// WEBPACK FOOTER //
// ./src/components/elements/Skill/SkilItem.js